/** The form column: whichever chapter the rail has selected. No `layout`, `cta`, `isLast`, `title`
 *  or activities — the working document carries whatever arrived, unrendered. */
import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { AssignmentChapter, ContentBlockOwner } from './store/interfaces'

import { useAssignmentEditorStore } from './store'

interface UseChapterEditorReturn {
  refChapter: ComputedRef<AssignmentChapter | null>
  /** `null` when nothing is selected. */
  refOwner: ComputedRef<ContentBlockOwner | null>
  /** `Chapter 3`. */
  refLabel: ComputedRef<string>
}

export const useChapterEditor = (): UseChapterEditorReturn => {
  const store = useAssignmentEditorStore()

  const refChapter = computed<AssignmentChapter | null>(() => store.getSelectedChapter)

  const refOwner = computed<ContentBlockOwner | null>(() => {
    const chapter = refChapter.value

    return chapter ? { screenId: chapter.id } : null
  })

  const refLabel = computed<string>(() => {
    const index = store.getSelectedChapterIndex

    return index < 0 ? '' : `Chapter ${index + 1}`
  })

  return {
    refChapter,
    refOwner,
    refLabel,
  }
}
